module.exports = __webpack_public_path__ + "img/axo_triste.37798d69.svg";